import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CheckBox from '../app/components/CheckBox';
import { Button } from '../app/components/Button';
import { Input } from '../app/components/Input';
import { FiChevronRight, FiEye, FiEyeOff } from 'react-icons/fi';
import Toast from '../app/components/Toast';
import authService from '../services/authService';
import * as motion from "motion/react-client";

function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState({ visible: false, type: '', message: '' });

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      navigate('/home');
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const showToast = (type, message) => {
    setToast({ visible: true, type, message });
    if (type === 'success') {
      setTimeout(() => {
        setToast(prev => ({ ...prev, visible: false }));
      }, 2000);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authService.login(formData.email, formData.password);
      const token = response?.token || 'FAKE_TOKEN';
      if (formData.rememberMe) {
        localStorage.setItem("auth_token", token);
        localStorage.setItem("auth_email", formData.email);
      } else {
      }

      showToast('success', 'Login realizado com sucesso! Redirecionando...');
      setTimeout(() => {
        navigate('/home');
      }, 1500);

    } catch (error) {
      let errorMessage = 'Ocorreu um erro durante o login.';
      if (error.response) {
        if (error.response.status === 401) {
          errorMessage = 'Email ou senha incorretos. Por favor, tente novamente.';
        } else {
          errorMessage = `Erro ${error.response.status}: ${error.response.data?.detail || 'Falha na autenticação'}`;
        }
      } else if (error.request) {
        errorMessage = 'Sem resposta do servidor. Verifique sua conexão.';
      }

      showToast('error', errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative h-screen w-screen overflow-hidden flex items-center justify-center py-8 authentication-bg">
      {toast.visible && (
        <div className="fixed top-4 right-4 z-50">
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(prev => ({ ...prev, visible: false }))}
          />
        </div>
      )}

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 3 }}
        >
          <img
            src="/assets/symbol_sequence_color.svg"
            className="absolute top-1/2 right-0 w-[120%] h-[120%] object-contain opacity-10 pointer-events-none -translate-y-1/2 translate-x-1/4"
          />
        </motion.div>

        <div className="flex-1 p-2 bg-white flex flex-col justify-center max-w-[40rem] min-w-[26vw] mx-auto">
          <div className="text-center mb-4">
            <img src="/assets/logo_color.svg" alt="sequence" className="h-16 mx-auto" />
          </div>
          <p className='text-center font-medium mt-12 mb-4'>Entre na sua conta:</p>

          <form id="loginForm" onSubmit={handleSubmit} autoComplete="on">
            <Input
              label="Email"
              id="email"
              name="email"
              type="email"
              autoComplete="null"
              placeholder="Entre com seu e-mail"
              value={formData.email}
              onChange={handleChange}
            />

            <div className="mb-3">
              <div className="relative">
                <Input
                  label="Senha"
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="null"
                  placeholder="Entre com sua senha"
                  value={formData.password}
                  onChange={handleChange}
                  className="pr-10"
                />
                <button
                  className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-600 hover:text-gray-800"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex="-1"
                >
                  {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                </button>
              </div>
            </div>

            <div className="mb-3">
              <CheckBox
                title="Continuar conectado"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleChange}
              />
            </div>

            <div className="text-center mt-3">
              <Button
                type="submit"
                variant="primary"
                className="w-full text-md py-[0.45rem] px-2 shadow-sm h-12 mt-10"
                icon={<FiChevronRight size={16} color="white" />}
                disabled={loading}
              >
                {loading ? 'Entrando...' : 'Acessar'}
              </Button>
            </div>
          </form>
        </div>
      </motion.div>
    </div>
  );
}

export default Login;
